import dashboardNL from './dashboard';
import menuAboutNL from './menuAbout';
import labelsNL from './labels';
import releasesNL from './releases';
import artistsNL from './artists';
import artistsWishlistNL from './artistsWishlist';
import profileNL from './profile';
import musicLinksNL from './musicLinks';
import linkLandingPagesNL from './linkLandingPages';
import masteringNL from './mastering';
import featureNL from './feature';
import accountingNL from './accounting';
import paymentMethodsNL from './paymentMethods';
import purchaseHistoryNL from './purchaseHistory';
import trendsNL from './trends';
import earningsDrilldownNL from './earningsDrilldown';
import invoicesNL from './invoices';
import statementsNL from './statements';
import subuserStatementsNL from './subuserStatements';
import userDataFormNL from './userDataForm';
import creditsNL from './credits';
import disputeClaimsNL from './disputeClaims';
import musicLinkUrlPartsNL from './musicLinkUrlParts';
import subscriptionNL from './subscription';
import twoFactorAuthNL from './twoFactorAuth';
import generalNL from './general';
import routerNL from './router';
import escrowWalletNL from './escrowWallet';
import subUsersNL from './subUsers';
import tokensNL from './tokens';
import tracksNL from './tracks';
import acrAlertNL from './acrAlert';
import qcNoteNL from './qcNote';
import flaggedContentNL from './flaggedContent';
import deliveryConfirmationNL from './deliveryConfirmation';
import preScanNL from './preScan';
import accessKeysNL from './accessKeys';
import announcementsNL from './announcements';

const translationNL = {
    'router': routerNL,
    'general': generalNL,
    'dashboard': dashboardNL,
    'menuAbout': menuAboutNL,
    'labels': labelsNL,
    'artists': artistsNL,
    'artistsWishlist': artistsWishlistNL,
    'releases': releasesNL,
    'tracks': tracksNL,
    'profile': profileNL,
    'musicLinks': musicLinksNL,
    'musicLinkUrlParts': musicLinkUrlPartsNL,
    'linkLandingPages': linkLandingPagesNL,
    'mastering': masteringNL,
    'feature': featureNL,
    'accounting': accountingNL,
    'paymentMethods': paymentMethodsNL,
    'purchaseHistory': purchaseHistoryNL,
    'trends': trendsNL,
    'earningsDrilldown': earningsDrilldownNL,
    'invoices': invoicesNL,
    'statements': statementsNL,
    'subuserStatements': subuserStatementsNL,
    'credits': creditsNL,
    'userDataForm': userDataFormNL,
    'disputeClaims': disputeClaimsNL,
    'subscription': subscriptionNL,
    'twoFactorAuth': twoFactorAuthNL,
    'escrowWallet': escrowWalletNL,
    'subUsers': subUsersNL,
    'tokens': tokensNL,
    'acrAlert': acrAlertNL,
    'qcNote': qcNoteNL,
    'flaggedContent': flaggedContentNL,
    'deliveryConfirmation': deliveryConfirmationNL,
    'preScan': preScanNL,
    'accessKeys': accessKeysNL,
    'announcements': announcementsNL,
};

export default translationNL;
